module.exports = __webpack_public_path__ + "6a989c89d5ac3c175a232962fc9fb431.png";